export default "__VITE_ASSET__BzZmj6f$__"